<sd-navbar [admin]="true"></sd-navbar>

<div class="container">
  <router-outlet></router-outlet>
</div>